var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","color":"red","outlined":"","loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("Delete")])}
var staticRenderFns = []

export { render, staticRenderFns }